import "rxjs/Rx";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export class LandingService {
  public searchData: any;
  constructor(private http: HttpClient) { }

  getInternalScreenData(keyword, consultanId) {
    if (consultanId) {
      return this.http.get(`/api/InternalScreen/getInternalData`, {
        params: { value: keyword, CONSULTANT_ID: consultanId },
        responseType: "json",
        observe: "response"
      });
    } else {
      return this.http.get(`/api/InternalScreen/getInternalData`, {
        params: { value: keyword },
        responseType: "json",
        observe: "response"
      });
    }
  }

  getCompletedInternalScreenData(keyword, days, consultanId) {
    if (consultanId) {
      return this.http.get(`/api/InternalScreen/getCompletedInternalData`, {
        params: { value: keyword, days: days, CONSULTANT_ID: consultanId },
        responseType: "json",
        observe: "response"
      });
    } else {
      return this.http.get(`/api/InternalScreen/getCompletedInternalData`, {
        params: { value: keyword, days: days },
        responseType: "json",
        observe: "response"
      });
    }
  }

  getInternalCountData() {
    return this.http.get(`/api/InternalScreen/getCountForLanding`, {
      responseType: "json"
    });
  }

  getDays() {
    return this.http.get(`/api/InternalScreen/getDays`, {
      responseType: "json"
    });
  }

  postAssignTo(data) {
    return this.http.post("/api/InternalScreen/postAssignTo", {
      params: { value: data },
      responseType: "json",
      observe: "response"
    });
  }

  assignTo(data) {
    return this.http.put(
      "/api/internalRequest/updateRequestForConsultantId",
      data,
      { observe: "response" }
    );
  }

  getRequestbyConsultantId(data): any {
    return this.http.get(`/api/internalRequest/getRequestByConsultantId`, {
      params: {
        CONSULTANT_ID: data
      },
      responseType: "json",
      observe: "response"
    });
  }

  getRequestCountByConsultantId(consultant_id: string) {
    return this.http.get("/api/internalRequest/getRequestCountByConsultantId", {
      params: {
        CONSULTANT_ID: consultant_id
      },
      responseType: "json",
      observe: "response"
    });
  }

  getRequestStatusCodes() {
    return this.http.get(`/api/search/getRequestStatusCode`, {
      params: {},
      responseType: "json"
    });
  }

  getTest() {
    return this.http.get(`/api/Test/getTest`);
  }

  getTestDatesByTest(testId) {
    return this.http.get(`/api/TestDate/getTestDatesByTest`, {
      params: { id: testId },
      responseType: "json",
      observe: "response"
    });
  }

  getSearchData(searchData) {
    return this.http.get(`/api/search/getSearchData`, {
      params: searchData,
      responseType: "json",
      observe: "response"
    });
  }

  getSearchCount(searchData) {
    return this.http.get(`/api/search/getSearchCount`, {
      params: searchData,
      responseType: "json",
      observe: "response"
    });
  }

  setSearchResult(result) {
    this.searchData = result;
  }

  getSearchResult() {
    return this.searchData;
  }
}



// WEBPACK FOOTER //
// ./client/views/services/landing.service.ts